/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_WhereInputs */

const th_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลายทางการแจ้งเตือน`)
};

const en_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where notifications go`)
};

const ja_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知の届け先`)
};

const zh_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知发送到哪里`)
};

const es_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dónde llegan las notificaciones`)
};

const pt_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para onde vão as notificações`)
};

const id_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ke mana notifikasi dikirim`)
};

const fr_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où vont les notifications`)
};

const tl_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saan napupunta ang mga notipikasyon`)
};

const vi_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo được gửi đi đâu`)
};

const ko_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림이 가는 곳`)
};

const de_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wohin Benachrichtigungen gehen`)
};

const ru_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Куда приходят уведомления`)
};

const tr_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler nereye gidiyor`)
};

const it_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove arrivano le notifiche`)
};

const pl_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokąd trafiają powiadomienia`)
};

const uk_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Куди надходять сповіщення`)
};

const hi_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ कहाँ जाती हैं`)
};

const ar_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلى أين تذهب الإشعارات`)
};

const ms_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ke mana pemberitahuan pergi`)
};

const bn_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিজ্ঞপ্তি কোথায় যায়`)
};

const zh_tw2_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知會送到哪裡`)
};

const zh_hk2_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知會送到哪裡`)
};

const ur_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلاعات کہاں جاتی ہیں`)
};

const fa_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعلان‌ها کجا می‌روند`)
};

const sw_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa zinakwenda wapi`)
};

const nl_notifications_where = /** @type {(inputs: Notifications_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar meldingen heen gaan`)
};

/**
* | output |
* | --- |
* | "Where notifications go" |
*
* @param {Notifications_WhereInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const notifications_where = /** @type {((inputs?: Notifications_WhereInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_WhereInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_notifications_where(inputs)
	if (locale === "ja") return ja_notifications_where(inputs)
	if (locale === "zh") return zh_notifications_where(inputs)
	if (locale === "es") return es_notifications_where(inputs)
	if (locale === "pt") return pt_notifications_where(inputs)
	if (locale === "id") return id_notifications_where(inputs)
	if (locale === "fr") return fr_notifications_where(inputs)
	if (locale === "tl") return tl_notifications_where(inputs)
	if (locale === "vi") return vi_notifications_where(inputs)
	if (locale === "ko") return ko_notifications_where(inputs)
	if (locale === "de") return de_notifications_where(inputs)
	if (locale === "ru") return ru_notifications_where(inputs)
	if (locale === "tr") return tr_notifications_where(inputs)
	if (locale === "it") return it_notifications_where(inputs)
	if (locale === "pl") return pl_notifications_where(inputs)
	if (locale === "uk") return uk_notifications_where(inputs)
	if (locale === "hi") return hi_notifications_where(inputs)
	if (locale === "ar") return ar_notifications_where(inputs)
	if (locale === "ms") return ms_notifications_where(inputs)
	if (locale === "bn") return bn_notifications_where(inputs)
	if (locale === "zh-TW") return zh_tw2_notifications_where(inputs)
	if (locale === "zh-HK") return zh_hk2_notifications_where(inputs)
	if (locale === "ur") return ur_notifications_where(inputs)
	if (locale === "fa") return fa_notifications_where(inputs)
	if (locale === "sw") return sw_notifications_where(inputs)
	if (locale === "nl") return nl_notifications_where(inputs)
	return en_notifications_where(inputs)
});